import React from "react";

export const Admin: React.FC<any> = () => <></>;
